import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { TransitionMotion, spring } from 'react-motion';

export default function Transition(props) {

  let defaultStyles = [], styles = [];
  const leaveParams = props.leaveParams || {stiffness: 250, damping: 20};
  const leaveStyle = { opacity: spring(0, leaveParams) }

  const enterParams = props.enterParams || null;

  React.Children.forEach(props.children, (child, i) => {
    if(child){
      defaultStyles.push({ key: child.key, data: child, style: {opacity: 0} });
      styles.push({ key: child.key, data: child, style: {opacity: spring(1, enterParams)} });
    }
  });

  var exitingStyles;
  var exitPending = false;

  function staggerStyles(prev, nextStyle){

    const exitingEles = prev.filter((item) => {
      const index = nextStyle.findIndex(nextItem => nextItem.key === item.key);
      return index < 0;
    });

    if(exitingEles.length > 0 && !exitPending) {
      exitingStyles = exitingEles.map((item) => {
        return {key: item.key, data: item.data, style: leaveStyle}
      });
      exitPending = true;
    }

    if(exitPending) {
      const exitingPrev = prev.filter((ele) => {
        const index = exitingEles.findIndex(exitingEle => exitingEle.key === ele.key);
        return index >= 0;
      });

      exitPending = !exitingPrev.every((ele) => ele.style.opacity === 0);
      const style = exitPending ? exitingStyles : nextStyle;
      return style;
    }

    return nextStyle;
  }


  return (
    <TransitionMotion
      defaultStyles = {defaultStyles}
      styles = {(prev) => staggerStyles(prev, styles)}
      willEnter = {() => ({opacity: 0}) }
      >
      {
        (styles) => <div>{
          styles.map((child) => {
            const {key, data, style} = child;
            return React.cloneElement(data, {key: key, style: style});
          })}
        </div>
      }
    </TransitionMotion>
      );
}



// WEBPACK FOOTER //
// ./src/components/Misc/Transition.js